import { CheckCircle2, AlertTriangle } from "lucide-react";

type Chip = {
  label: string;
  tone: "success" | "info" | "warning" | "error";
};

const TONE: Record<Chip["tone"], string> = {
  success: "border-emerald-300 bg-emerald-50 text-emerald-700",
  info: "border-brand-300 bg-brand-50 text-brand-700",
  warning: "border-amber-300 bg-amber-50 text-amber-700",
  error: "border-red-300 bg-red-50 text-red-700",
};

type Props = {
  totalProcessed: number;
  chips: Chip[];
  errorDetails: string[];
};

export function ImportResultView({ totalProcessed, chips, errorDetails }: Props) {
  return (
    <div className="space-y-4 py-4 text-center">
      <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-emerald-50 text-emerald-600">
        <CheckCircle2 className="h-8 w-8" />
      </div>
      <div>
        <h3 className="text-base font-semibold text-zinc-900">Importacao concluida</h3>
        <p className="mt-1 text-xs text-zinc-500">
          Total processado: <strong>{totalProcessed}</strong> registros
        </p>
      </div>
      <div className="flex flex-wrap justify-center gap-2">
        {chips.map((c) => (
          <span
            key={c.label}
            className={`inline-flex items-center rounded-full border px-2.5 py-1 text-[11px] font-medium ${TONE[c.tone]}`}
          >
            {c.label}
          </span>
        ))}
      </div>
      {errorDetails.length > 0 && (
        <div className="mt-2 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-left">
          <div className="mb-1.5 flex items-center gap-2 text-xs font-semibold text-amber-900">
            <AlertTriangle className="h-3.5 w-3.5" />
            Detalhes dos erros
          </div>
          <ul className="space-y-0.5 text-[11px] text-amber-800">
            {errorDetails.map((msg, i) => (
              <li key={i} className="font-mono">{msg}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
